import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { LocationProvider } from "@/context/LocationContext";
import { DataProvider } from "@/context/DataContext";
import InstallPrompt from "@/components/InstallPrompt";
import { Loader2 } from "lucide-react";

import Home from "@/pages/Home";
import CategoriesPage from "@/pages/CategoriesPage";
import CategoryPage from "@/pages/CategoryPage";
import SearchPage from "@/pages/SearchPage";
import OffersPage from "@/pages/OffersPage";
import NearbyPage from "@/pages/NearbyPage";
import BusinessDetail from "@/pages/BusinessDetail";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function ProtectedRoute({ children }) {
  const { admin, ready } = useAuth();
  if (!ready)
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#FDFBF7]">
        <Loader2 className="animate-spin text-[#E54D2E]" size={28} />
      </div>
    );
  if (!admin) return <Navigate to="/admin/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <DataProvider>
          <LocationProvider>
            <Toaster position="top-center" richColors />
            <BrowserRouter>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/categorias" element={<CategoriesPage />} />
                <Route path="/categoria/:slug" element={<CategoryPage />} />
                <Route path="/buscar" element={<SearchPage />} />
                <Route path="/ofertas" element={<OffersPage />} />
                <Route path="/cerca" element={<NearbyPage />} />
                <Route path="/negocio/:id" element={<BusinessDetail />} />
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
              <InstallPrompt />
            </BrowserRouter>
          </LocationProvider>
        </DataProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
